import { render, staticRenderFns } from "./SsInvestmentPage.vue?vue&type=template&id=2be04d62"
import script from "./SsInvestmentPage.vue?vue&type=script&lang=ts"
export * from "./SsInvestmentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports